import debounce from 'lodash/debounce'

const navSearchWrap = document.querySelector('#navigation-search-wrap')
const navSearchField = document.querySelector('#navigation-search')
const navSearchBox = document.querySelector('#mtt-header-search-box')
const navSearchResults = document.querySelector('#mtt-header-search-results')
const navSearchButton = document.querySelector('#navigation-search-button')

function handleErrors(error) {
    console.log(error)
}

function showLoader() {
    navSearchBox.classList.add('mtt-header-search-box--loading')
}

function hideLoader() {
    navSearchBox.classList.remove('mtt-header-search-box--loading')
}

function showSearchBox() {
    navSearchBox.classList.add('mtt-header-search-box--active')
}

function hideSearchBox() {
    navSearchBox.classList.remove('mtt-header-search-box--active')
}

function clearSearchBox() {
    navSearchResults.innerHTML = ''
}

function toggleMobileSearch() {
    const activeClass = 'mtt-header-search--show'

    if (navSearchWrap.classList.contains(activeClass)) {
        navSearchWrap.classList.remove('mtt-header-search--show')
        hideSearchBox()
    } else {
        navSearchWrap.classList.add('mtt-header-search--show')
    }

}

function handleSearch(event) {
    const ignoredKeys = [16, 17, 18, 91, 37, 38, 39, 40]

    if (parseInt(event.keyCode) === 27) {
        return
    }

    if (ignoredKeys.indexOf(parseInt(event.keyCode)) > 0) {
        return
    }

    if (navSearchField.value.length < 2) {
        clearSearchBox()
        hideSearchBox()
    } else {
        showSearchBox()
        doSearch(navSearchField.value)
    }
}

function doSearch(searchString) {
    const data = {
        action: 'nav_search',
        search: searchString
    }

    showLoader()

    jQuery
        .post(main_theme_objects.ajax_url, data, response => {
            if (response != 0) {
                navSearchResults.innerHTML = response.markup
            }
        })
        .fail(error => handleErrors(error))
        .always(() => hideLoader())
}

export default function NavigationSearch() {
    if (!navSearchField) {
        return
    }

    const debounceSearch = debounce(event => handleSearch(event),400)

    navSearchField.addEventListener('keyup', debounceSearch)

    navSearchField.addEventListener('keyup', event => {
        if (parseInt(event.keyCode) === 27) {
            hideSearchBox()
        }
    })

    navSearchField.addEventListener('focus', event => {
        if (navSearchField.value.length >= 3) {
            doSearch(navSearchField.value)
            showSearchBox()
        }
    })

    navSearchButton.addEventListener('click', () => toggleMobileSearch())

    document.addEventListener('click', event => {
        if (!event.composedPath().includes(navSearchWrap)) {
            hideSearchBox()
        }
    })
}